import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../Slice/User/Index'

export default configureStore({
    reducer:{
        user: userReducer
    }
})